// src/routes.js
import React, {useContext} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';

import COM001L1 from "pages/COM/COM001L1";
import COM001L2 from "pages/COM/COM001L2";

import COM201F1 from "pages/COM/COM201F1";
import COM101F1 from "pages/COM/COM101F1";

import {AuthContext} from "contexts/AuthContext";
import Loading from "config/Loading";
import PreventBack from "./PreventBack";

const MainRoutes = () => {

    const authContext = useContext(AuthContext);

    return (
        <Router>
            <PreventBack/>
            <Routes>
                <Route element={<COM001L1 />}>
                    <Route path="/main"         element={<COM201F1 />} />
                </Route>

                <Route element={<COM001L2 />}>
                    <Route path="/" element={
                        authContext.isLoggedIn ? <Navigate to="/main" replace />
                            : <COM101F1 />
                    } />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Loading />
        </Router>
    );
};

export default MainRoutes;